import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { reduxForm, Field, FieldArray, change } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import { browserHistory } from 'react-router';
import Alert from 'react-bootstrap/lib/Alert';
import InputField from 'components/InputField';
import * as validators from 'utils/validators';
import CustomerSearchField from 'components/drafts/CustomerSearchField';
import LineItemsEditor from 'components/drafts/LineItemsEditor';

const PREFIX_VALIDATORS = [validators.prefix, validators.maxLength(20)];
const NUMBER_VALIDATORS = [validators.positiveInteger];
import {
  createDraft, updateDraft, selectDraft, searchCustomers, fetchDraft
} from 'modules/drafts';

class DraftEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sameAsShipping: false
    };
  }

  componentDidMount() {
    let { params, dispatch } = this.props;
    if (params && params.id && params.id !== 'new') {
      dispatch(fetchDraft(params.id));
    } else {
      dispatch(selectDraft({
        document_type: 'draft_order',
        currency: 'USD',
        status: 'draft',
        line_items: [{ title: '', quantity: 1, unit_price: 0, tax_rate: 0, discount_value: 0, discount_type: 'fixed' }]
      }));
    }
  }

  onCustomerSelect(customer) {
    let { dispatch } = this.props;
    let addr = customer.default_address || customer.defaultAddress || {};
    dispatch(change('draftEdit', 'customer.first_name', customer.first_name || ''));
    dispatch(change('draftEdit', 'customer.last_name', customer.last_name || ''));
    dispatch(change('draftEdit', 'customer.email', customer.email || ''));
    dispatch(change('draftEdit', 'customer.phone', customer.phone || ''));
    dispatch(change('draftEdit', 'customer.company', addr.company || customer.company || ''));
    dispatch(change('draftEdit', 'customer.tax_id', customer.tax_id || ''));
    dispatch(change('draftEdit', 'customer.shopify_customer_id', customer.id || ''));

    if (addr.address1 || addr.city) {
      dispatch(change('draftEdit', 'billing_address.address1', addr.address1 || ''));
      dispatch(change('draftEdit', 'billing_address.address2', addr.address2 || ''));
      dispatch(change('draftEdit', 'billing_address.city', addr.city || ''));
      dispatch(change('draftEdit', 'billing_address.province', addr.province || ''));
      dispatch(change('draftEdit', 'billing_address.country', addr.country || ''));
      dispatch(change('draftEdit', 'billing_address.zip', addr.zip || ''));
    }
  }

  onSameAsShippingChange(e) {
    let checked = e.target.checked;
    this.setState({ sameAsShipping: checked });

    if (checked) {
      let { formValues, dispatch } = this.props;
      let billing = (formValues && formValues.billing_address) || {};
      dispatch(change('draftEdit', 'shipping_address.address1', billing.address1 || ''));
      dispatch(change('draftEdit', 'shipping_address.address2', billing.address2 || ''));
      dispatch(change('draftEdit', 'shipping_address.city', billing.city || ''));
      dispatch(change('draftEdit', 'shipping_address.province', billing.province || ''));
      dispatch(change('draftEdit', 'shipping_address.country', billing.country || ''));
      dispatch(change('draftEdit', 'shipping_address.zip', billing.zip || ''));
    }
  }

  getSubtotal() {
    let items = (this.props.formValues && this.props.formValues.line_items) || [];
    let subtotal = 0;
    for (let i = 0; i < items.length; i++) {
      subtotal += (Number(items[i].quantity) || 0) * (Number(items[i].unit_price) || 0);
    }
    return subtotal;
  }

  getTax() {
    let items = (this.props.formValues && this.props.formValues.line_items) || [];
    let tax = 0;
    for (let i = 0; i < items.length; i++) {
      let lineTotal = (Number(items[i].quantity) || 0) * (Number(items[i].unit_price) || 0);
      let discountValue = Number(items[i].discount_value) || 0;
      let discountType = items[i].discount_type || 'fixed';
      if (discountType === 'percentage') lineTotal -= lineTotal * (discountValue / 100);
      else lineTotal -= discountValue;
      tax += lineTotal * ((Number(items[i].tax_rate) || 0) / 100);
    }
    return tax;
  }

  getDiscounts() {
    let items = (this.props.formValues && this.props.formValues.line_items) || [];
    let discounts = 0;
    for (let i = 0; i < items.length; i++) {
      let lineTotal = (Number(items[i].quantity) || 0) * (Number(items[i].unit_price) || 0);
      let discountValue = Number(items[i].discount_value) || 0;
      let discountType = items[i].discount_type || 'fixed';
      if (discountType === 'percentage') discounts += lineTotal * (discountValue / 100);
      else discounts += discountValue;
    }
    return discounts;
  }

  getShipping() {
    let shipping = (this.props.formValues && this.props.formValues.shipping_lines) || {};
    return Number(shipping.price) || 0;
  }

  getTotal() {
    return this.getSubtotal() - this.getDiscounts() + this.getTax() + this.getShipping();
  }

  onSave(formValues) {
    let { params, dispatch } = this.props;
    if (params && params.id && params.id !== 'new') {
      dispatch(updateDraft({ draft: formValues })).then((result) => {
        if (result && result.ok) browserHistory.push('/drafts');
      });
    } else {
      dispatch(createDraft({ draft: formValues })).then((result) => {
        if (result && result.ok) browserHistory.push('/drafts');
      });
    }
  }

  onSearchCustomers(query) {
    this.props.dispatch(searchCustomers(query));
  }

  render() {
    let { handleSubmit, submitting, params, customers, user, intl } = this.props;
    const t = (id) => intl.formatMessage({ id });
    let isNew = !params || !params.id || params.id === 'new';
    let documentType = (this.props.formValues && this.props.formValues.document_type) || 'draft_order';
    let shopifyDraftOrderId = this.props.formValues && this.props.formValues.shopify_draft_order_id;
    let shopName = user && user.shopify && user.shopify.shopName;

    return (
      <div>
        <Grid fluid>
          <div className="sidebar">
            <Col md={6}>
              <span>{isNew ? t('draftEdit.newDraft') : t('draftEdit.editDraft')}</span>
              {shopifyDraftOrderId && shopName && (
                <a
                  href={`https://admin.shopify.com/store/${shopName}/draft_orders/${shopifyDraftOrderId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: '12px', fontSize: '12px', color: '#ccc' }}
                >
                  <i className="fa fa-external-link"></i> {t('draftEdit.viewInShopify')}
                </a>
              )}
            </Col>
            <Col md={6}>
              <div className="btn-group pull-right">
                <Button bsStyle="default" onClick={() => browserHistory.push('/drafts')}>
                  <i className="fa fa-arrow-left"></i> {t('draftEdit.back')}
                </Button>
                &nbsp;
                <Button disabled={submitting} bsStyle="success" onClick={handleSubmit((v) => this.onSave(v))}>
                  <i className="fa fa-check"></i> {isNew ? t('draftEdit.createDraft') : t('draftEdit.saveChanges')}
                </Button>
              </div>
            </Col>
          </div>
        </Grid>

        <form className="draft-edit-page" onSubmit={handleSubmit((v) => this.onSave(v))}>
          <div className="container-fluid" style={{ paddingTop: '10px' }}>

            {this.props.saveError && (
              <Alert bsStyle="danger">
                <i className="fa fa-exclamation-circle"></i>&nbsp;{this.props.saveError}
              </Alert>
            )}

            {/* Top row: Type + Currency + Expiry */}
            <div className="panel panel-default">
              <div className="panel-body">
                <Row>
                  <Col md={4}>
                    <OverlayTrigger placement="top" overlay={
                      <Tooltip id="prefix-tip">Prefix shown before the number. Examples: D-, Q-. Letters, numbers and dashes only. Leave empty for your shop default.</Tooltip>
                    }>
                      <label style={{ cursor: 'help' }}>{t('draftEdit.prefix')} <i className="fa fa-question-circle" /></label>
                    </OverlayTrigger>
                    <Field
                      className="form-control"
                      name="prefix"
                      component={InputField}
                      type="text"
                      placeholder="D-"
                      validate={PREFIX_VALIDATORS}
                      autoComplete="off"
                      disabled={this.props.formValues && this.props.formValues.status && this.props.formValues.status !== 'draft'}
                    />
                  </Col>
                  <Col md={4}>
                    <OverlayTrigger placement="top" overlay={
                      <Tooltip id="number-tip">Start this draft at a specific number. Example: 1234. Leave empty to number automatically.</Tooltip>
                    }>
                      <label style={{ cursor: 'help' }}>{t('draftEdit.number')} <i className="fa fa-question-circle" /></label>
                    </OverlayTrigger>
                    <Field
                      className="form-control"
                      name="draft_number"
                      component={InputField}
                      type="number"
                      placeholder="1234"
                      validate={NUMBER_VALIDATORS}
                      autoComplete="off"
                      disabled={this.props.formValues && this.props.formValues.status && this.props.formValues.status !== 'draft'}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <label>{t('draftEdit.documentType')}</label>
                    <Field className="form-control" name="document_type" component="select">
                      <option value="draft_order">{t('draftEdit.draftOrder')}</option>
                      <option value="quote">{t('draftEdit.quote')}</option>
                      <option value="proforma">{t('draftEdit.proforma')}</option>
                      <option value="manual_invoice">{t('draftEdit.manualInvoice')}</option>
                    </Field>
                  </Col>
                  <Col md={3}>
                    <label>{t('draftEdit.currency')}</label>
                    <Field className="form-control" name="currency" component="select">
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      <option value="CAD">CAD</option>
                      <option value="AUD">AUD</option>
                      <option value="CHF">CHF</option>
                      <option value="JPY">JPY</option>
                      <option value="SEK">SEK</option>
                      <option value="NOK">NOK</option>
                      <option value="DKK">DKK</option>
                      <option value="NZD">NZD</option>
                      <option value="SGD">SGD</option>
                      <option value="HKD">HKD</option>
                      <option value="INR">INR</option>
                      <option value="BRL">BRL</option>
                      <option value="MXN">MXN</option>
                      <option value="PLN">PLN</option>
                      <option value="RON">RON</option>
                      <option value="CZK">CZK</option>
                      <option value="HUF">HUF</option>
                      <option value="ILS">ILS</option>
                      <option value="ZAR">ZAR</option>
                      <option value="AED">AED</option>
                      <option value="THB">THB</option>
                    </Field>
                  </Col>
                  {documentType === 'quote' && <Col md={3}>
                    <label>{t('draftEdit.expiryDate')}</label>
                    <Field className="form-control" name="expiry_date" component={InputField} type="date" />
                  </Col>}
                  <Col md={2}>
                    <label>{t('draftEdit.status')}</label>
                    <Field className="form-control" name="status" component="select">
                      <option value="draft">{t('draftEdit.draft')}</option>
                      <option value="sent">{t('draftEdit.sent')}</option>
                      <option value="accepted">{t('draftEdit.accepted')}</option>
                    </Field>
                  </Col>
                </Row>
              </div>
            </div>

            <Row>
              {/* Left: Customer */}
              <Col md={6}>
                <div className="panel panel-default">
                  <div className="panel-heading"><strong>{t('draftEdit.customer')}</strong></div>
                  <div className="panel-body">
                    <div style={{ marginBottom: '8px' }}>
                      <CustomerSearchField
                        customers={customers}
                        onSearch={(q) => this.onSearchCustomers(q)}
                        onSelect={(c) => this.onCustomerSelect(c)}
                      />
                    </div>
                    <Row>
                      <Col md={6}>
                        <label>{t('draftEdit.firstName')}</label>
                        <Field className="form-control" name="customer.first_name" component={InputField} type="text" label={t('draftEdit.firstName')} />
                      </Col>
                      <Col md={6}>
                        <label>{t('draftEdit.lastName')}</label>
                        <Field className="form-control" name="customer.last_name" component={InputField} type="text" label={t('draftEdit.lastName')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <label>{t('draftEdit.email')}</label>
                        <Field className="form-control" name="customer.email" component={InputField} type="email" label={t('draftEdit.email')} />
                      </Col>
                      <Col md={6}>
                        <label>{t('draftEdit.phone')}</label>
                        <Field className="form-control" name="customer.phone" component={InputField} type="text" label={t('draftEdit.phone')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <label>{t('draftEdit.company')}</label>
                        <Field className="form-control" name="customer.company" component={InputField} type="text" label={t('draftEdit.company')} />
                      </Col>
                      <Col md={6}>
                        <label>{t('draftEdit.taxId')}</label>
                        <Field className="form-control" name="customer.tax_id" component={InputField} type="text" label={t('draftEdit.taxId')} />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>

              {/* Right: Billing + Shipping */}
              <Col md={6}>
                <div className="panel panel-default">
                  <div className="panel-heading"><strong>{t('draftEdit.billingAddress')}</strong></div>
                  <div className="panel-body">
                    <Row>
                      <Col md={8}>
                        <label>{t('draftEdit.address')}</label>
                        <Field className="form-control" name="billing_address.address1" component={InputField} type="text" label={t('draftEdit.address')} />
                      </Col>
                      <Col md={4}>
                        <label>{t('draftEdit.aptSuite')}</label>
                        <Field className="form-control" name="billing_address.address2" component={InputField} type="text" label={t('draftEdit.aptSuite')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <label>{t('draftEdit.city')}</label>
                        <Field className="form-control" name="billing_address.city" component={InputField} type="text" label={t('draftEdit.city')} />
                      </Col>
                      <Col md={3}>
                        <label>{t('draftEdit.province')}</label>
                        <Field className="form-control" name="billing_address.province" component={InputField} type="text" label={t('draftEdit.province')} />
                      </Col>
                      <Col md={3}>
                        <label>{t('draftEdit.countryField')}</label>
                        <Field className="form-control" name="billing_address.country" component={InputField} type="text" label={t('draftEdit.countryField')} />
                      </Col>
                      <Col md={2}>
                        <label>{t('draftEdit.zip')}</label>
                        <Field className="form-control" name="billing_address.zip" component={InputField} type="text" label={t('draftEdit.zip')} />
                      </Col>
                    </Row>
                  </div>
                </div>

                <div className="panel panel-default">
                  <div className="panel-heading">
                    <strong>{t('draftEdit.shippingAddress')}</strong>
                    <label style={{ marginLeft: '12px', fontWeight: 'normal', fontSize: '11px', textTransform: 'none' }}>
                      <input type="checkbox" checked={this.state.sameAsShipping} onChange={(e) => this.onSameAsShippingChange(e)} />
                      &nbsp;{t('draftEdit.sameAsBilling')}
                    </label>
                  </div>
                  {!this.state.sameAsShipping && <div className="panel-body">
                    <Row>
                      <Col md={8}>
                        <label>{t('draftEdit.address')}</label>
                        <Field className="form-control" name="shipping_address.address1" component={InputField} type="text" label={t('draftEdit.address')} />
                      </Col>
                      <Col md={4}>
                        <label>{t('draftEdit.aptSuite')}</label>
                        <Field className="form-control" name="shipping_address.address2" component={InputField} type="text" label={t('draftEdit.aptSuite')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <label>{t('draftEdit.city')}</label>
                        <Field className="form-control" name="shipping_address.city" component={InputField} type="text" label={t('draftEdit.city')} />
                      </Col>
                      <Col md={3}>
                        <label>{t('draftEdit.province')}</label>
                        <Field className="form-control" name="shipping_address.province" component={InputField} type="text" label={t('draftEdit.province')} />
                      </Col>
                      <Col md={3}>
                        <label>{t('draftEdit.countryField')}</label>
                        <Field className="form-control" name="shipping_address.country" component={InputField} type="text" label={t('draftEdit.countryField')} />
                      </Col>
                      <Col md={2}>
                        <label>{t('draftEdit.zip')}</label>
                        <Field className="form-control" name="shipping_address.zip" component={InputField} type="text" label={t('draftEdit.zip')} />
                      </Col>
                    </Row>
                  </div>}
                </div>
              </Col>
            </Row>

            {/* Line Items - full width */}
            <div className="panel panel-default">
              <div className="panel-heading"><strong>{t('draftEdit.lineItems')}</strong></div>
              <div className="panel-body" style={{ padding: '10px' }}>
                <FieldArray name="line_items" component={LineItemsEditor} />
              </div>
            </div>

            {/* Bottom row: Shipping + Note + Totals */}
            <Row>
              <Col md={4}>
                <div className="panel panel-default">
                  <div className="panel-heading"><strong>{t('draftEdit.shipping')}</strong></div>
                  <div className="panel-body">
                    <label>{t('draftEdit.shippingTitle')}</label>
                    <Field className="form-control" name="shipping_lines.title" component={InputField} type="text" label={t('draftEdit.shippingPlaceholder')} />
                    <label style={{ marginTop: '4px' }}>{t('draftEdit.price')}</label>
                    <Field className="form-control" name="shipping_lines.price" component={InputField} type="number" label="0.00" step="0.01" />
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="panel panel-default">
                  <div className="panel-heading"><strong>{t('draftEdit.note')}</strong></div>
                  <div className="panel-body">
                    <Field className="form-control" name="note" component="textarea" rows="4" placeholder={t('draftEdit.notePlaceholder')} />
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="panel panel-default">
                  <div className="panel-heading"><strong>{t('draftEdit.summary')}</strong></div>
                  <div className="panel-body">
                    <table className="table table-condensed" style={{ marginBottom: 0 }}>
                      <tbody>
                        <tr>
                          <td>{t('draftEdit.subtotal')}</td>
                          <td className="text-right">{this.getSubtotal().toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>{t('draftEdit.discounts')}</td>
                          <td className="text-right">{this.getDiscounts() > 0 ? '-' : ''}{this.getDiscounts().toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>{t('draftEdit.tax')}</td>
                          <td className="text-right">{this.getTax().toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>{t('draftEdit.shipping')}</td>
                          <td className="text-right">{this.getShipping().toFixed(2)}</td>
                        </tr>
                        <tr style={{ borderTop: '2px solid #ddd' }}>
                          <td><strong>{t('draftEdit.total')}</strong></td>
                          <td className="text-right"><strong>{this.getTotal().toFixed(2)}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>

          </div>
        </form>
      </div>
    );
  }
}

DraftEdit.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

let form = reduxForm({ form: 'draftEdit', enableReinitialize: true, touchOnChange: true })(DraftEdit);

form = connect((state) => {
  let selectedDraft = (state.drafts && state.drafts.selectedDraft) || {};
  return {
    initialValues: selectedDraft,
    customers: (state.drafts && state.drafts.customers) || [],
    formValues: state.form.draftEdit ? state.form.draftEdit.values : {},
    saveError: (state.drafts && state.drafts.saveError) || null,
    user: state.user
  };
})(form);

export default injectIntl(form);



// WEBPACK FOOTER //
// app/containers/DraftEdit.jsx